__turbopack_context__.v({
  "bay": "DeskShell-module__-XXPRq__bay",
  "bayBare": "DeskShell-module__-XXPRq__bayBare",
  "chip": "DeskShell-module__-XXPRq__chip",
  "chipPrimary": "DeskShell-module__-XXPRq__chipPrimary",
  "chipSuccess": "DeskShell-module__-XXPRq__chipSuccess",
  "chipWarning": "DeskShell-module__-XXPRq__chipWarning",
  "dotLive": "DeskShell-module__-XXPRq__dotLive",
  "dotOffline": "DeskShell-module__-XXPRq__dotOffline",
  "dotPaper": "DeskShell-module__-XXPRq__dotPaper",
  "dotWarning": "DeskShell-module__-XXPRq__dotWarning",
  "eyebrow": "DeskShell-module__-XXPRq__eyebrow",
  "eyebrowDot": "DeskShell-module__-XXPRq__eyebrowDot",
  "header": "DeskShell-module__-XXPRq__header",
  "headerCompact": "DeskShell-module__-XXPRq__headerCompact",
  "headerExtra": "DeskShell-module__-XXPRq__headerExtra",
  "headerRow": "DeskShell-module__-XXPRq__headerRow",
  "headerWide": "DeskShell-module__-XXPRq__headerWide",
  "lead": "DeskShell-module__-XXPRq__lead",
  "localLink": "DeskShell-module__-XXPRq__localLink",
  "localLinkActive": "DeskShell-module__-XXPRq__localLinkActive",
  "localNav": "DeskShell-module__-XXPRq__localNav",
  "module": "DeskShell-module__-XXPRq__module",
  "moduleBezel": "DeskShell-module__-XXPRq__moduleBezel",
  "moduleBezelLeft": "DeskShell-module__-XXPRq__moduleBezelLeft",
  "moduleBody": "DeskShell-module__-XXPRq__moduleBody",
  "moduleBodyFlush": "DeskShell-module__-XXPRq__moduleBodyFlush",
  "moduleBodyPadded": "DeskShell-module__-XXPRq__moduleBodyPadded",
  "moduleCount": "DeskShell-module__-XXPRq__moduleCount",
  "moduleExtra": "DeskShell-module__-XXPRq__moduleExtra",
  "moduleLabel": "DeskShell-module__-XXPRq__moduleLabel",
  "moduleMark": "DeskShell-module__-XXPRq__moduleMark",
  "moduleWide": "DeskShell-module__-XXPRq__moduleWide",
  "sessionBar": "DeskShell-module__-XXPRq__sessionBar",
  "sessionClock": "DeskShell-module__-XXPRq__sessionClock",
  "sessionContent": "DeskShell-module__-XXPRq__sessionContent",
  "sessionDivider": "DeskShell-module__-XXPRq__sessionDivider",
  "sessionDot": "DeskShell-module__-XXPRq__sessionDot",
  "sessionExtra": "DeskShell-module__-XXPRq__sessionExtra",
  "sessionStatus": "DeskShell-module__-XXPRq__sessionStatus",
  "sessionStatusText": "DeskShell-module__-XXPRq__sessionStatusText",
  "srOnly": "DeskShell-module__-XXPRq__srOnly",
  "statusRibbon": "DeskShell-module__-XXPRq__statusRibbon",
  "statusRibbonLeft": "DeskShell-module__-XXPRq__statusRibbonLeft",
  "statusRibbonRight": "DeskShell-module__-XXPRq__statusRibbonRight",
  "title": "DeskShell-module__-XXPRq__title",
  "titleGroup": "DeskShell-module__-XXPRq__titleGroup",
  "toolbar": "DeskShell-module__-XXPRq__toolbar",
  "toolbarLeft": "DeskShell-module__-XXPRq__toolbarLeft",
  "toolbarRight": "DeskShell-module__-XXPRq__toolbarRight",
});
